document.addEventListener('DOMContentLoaded', function() {
    //we get the neccessary data from the structured course data
    const jsonLdElement = document.querySelector('script[type="application/json"][data-snippet="structured-course-data"]');

    //we find data
    if (jsonLdElement) {
      try {

        const jsonData = JSON.parse(jsonLdElement.textContent);
    

        //format it into an object
        let productObject = {
          productId: jsonData.productID,
          url: jsonData.url,
          imageurl: jsonData.image.startsWith('http') ? jsonData.image : 'https:' + jsonData.image,
          title: jsonData.name,
          collection: jsonData.collection,
          productType: jsonData.productType
        };
    
        let viewedProducts = localStorage.getItem("viewedProducts");
    
        // there are already products that were viewed
        if (viewedProducts) {

          let parsedProducts = JSON.parse(viewedProducts);
    
          // check if the product was already viewed
          const alreadyExists = parsedProducts.some(p => p.productId === productObject.productId);
    
          if (!alreadyExists) {
            // Neues Produkt vorne einfügen
            parsedProducts.unshift(productObject);
    
            // we do not want more than 5 products
            if (parsedProducts.length > 5) {
              parsedProducts = parsedProducts.slice(0, 5);
            }
    
            //we update the local storage
            localStorage.setItem("viewedProducts", JSON.stringify(parsedProducts));
            
            let cartItems = document.querySelectorAll(".CartItem");
            if(cartItems.length > 0){
            
                const viewedProductEvent = new CustomEvent("viewed_product");
                window.dispatchEvent(viewedProductEvent);

            }
         
            
          }
        } else {
          // first entry
          localStorage.setItem("viewedProducts", JSON.stringify([productObject]));
          let cartItems = document.querySelectorAll(".CartItem");
            if(cartItems.length > 0){
            
                const viewedProductEvent = new CustomEvent("viewed_product");
                window.dispatchEvent(viewedProductEvent);

            }
        }
    
      } catch (e) {
        console.error("Fehler beim Parsen der JSON-LD Daten:", e);
      }
    } else {
      console.warn("Keine JSON-LD-Daten gefunden.");
    }
});